import TranslationsApiClient from '../api/TranslationsApiClient';
import { ILanguage } from '../types/ILanguage';

const fetchLanguages = () => {
    return new Promise<ILanguage[]>((resolve, reject) => {
     TranslationsApiClient.GetLanguages()
        .then((data: ILanguage[]) => {
            resolve(data);
        })
        .catch(_ => {
            reject();
        });
    });

}

export default fetchLanguages;